export enum AttemptResultFilterEnum {
  FAILED = 'failed',
  PASSED = 'passed',
}
